// extracted by mini-css-extract-plugin
module.exports = {"Menu":"styles_Menu__ohlyS","MoveIcon":"styles_MoveIcon__lQyS5","ArchiveToastWrapper":"styles_ArchiveToastWrapper__ESnF_","ArchiveToast":"styles_ArchiveToast__dp2PP"};